import { Guid } from "@/Common/Models/Guid";
import { TextRadioGroup } from "../TextRadioGroup/TextRadioGroup";

/**
 * The properties for a {@link YesNoNotApplicableTextRadioGroup} component.
 */
interface IYesNoNotApplicableTextRadioGroup {
    /**
     * A unique ID for the radio button group.
     */
    fieldsetId: Guid;

    /**
     * The accessible label for the radio group.
     */
    ariaLabel: string;

    /**
     * The selected value.
     */
    selectedValue?: boolean;

    /**
     * A callback to invoke when an option is selected. This receives the newly selected value.
     */
    onChange?: (selected: boolean) => void;

    /**
     * The HTML name for the radio button group.
     */
    name?: string;
}

function YesNoNotApplicableTextRadioGroup(props: Readonly<IYesNoNotApplicableTextRadioGroup>): JSX.Element {
    return (
        <TextRadioGroup
            fieldsetId={props.fieldsetId}
            ariaLabel={props.ariaLabel}
            name={props.name}
            items={[
                {
                    label: cacheStore.GetString("NALabel"),
                    value: null
                },
                {
                    label: cacheStore.GetString("YesLabel"),
                    value: true
                },
                {
                    label: cacheStore.GetString("NoLabel"),
                    value: false
                }
            ]}
            onChange={value => props.onChange?.(value)}
            selectedValue={props.selectedValue}
        />
    );
}

export { YesNoNotApplicableTextRadioGroup };
